import { Injectable, OnDestroy, inject } from '@angular/core';
import { interval, Subject, Subscription } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';
import { APIService } from './APIService/api.service';
import { AuthService } from './Auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AlertService implements OnDestroy {
  private api = inject(APIService);
  private auth = inject(AuthService);

  private alertSubject = new Subject<any[]>();
  alerts$ = this.alertSubject.asObservable();

  private pollingSub: Subscription;
  minuten: number = 5;
  invervall: number = 300000; // Standard = 5 min

  constructor() {
    this.invervall = this.minuten * 60 * 1000;
  }

  startPolling() {
    this.loadAlerts();
    this.pollingSub = interval(this.invervall)
      .pipe(
        filter(() => this.auth.isLoggedIn()),
        switchMap(() => this.api.getAlerts())
      )
      .subscribe((res: any) => {
        if (res?.success && res?.data?.length > 0) {
          this.alertSubject.next(res.data);
          this.removeOldConfirmedAlerts(res.oldids!);
        }
      });
  }

  private loadAlerts() {
    if (!this.auth.isLoggedIn()) return;

    this.api.getAlerts().subscribe((res: any) => {
      if (res?.success && res?.data?.length > 0) {
        this.alertSubject.next(res.data);
        this.removeOldConfirmedAlerts(res.oldids!);
      }
    });
  }

  removeOldConfirmedAlerts(oldIds: number[]) {
    let confirmedAlerts: number[] = JSON.parse(localStorage.getItem('confirmedAlerts') || '[]');
    confirmedAlerts = confirmedAlerts.filter(id => !oldIds.includes(id));
    localStorage.setItem('confirmedAlerts', JSON.stringify(confirmedAlerts));
  }

  stopPolling() {
    this.pollingSub?.unsubscribe();
  }

  ngOnDestroy() {
    this.stopPolling();
  }
}
